import { render, staticRenderFns } from "./ResourceFilePage.vue?vue&type=template&id=c7ffc0b0&"
import script from "./ResourceFilePage.vue?vue&type=script&lang=js&"
export * from "./ResourceFilePage.vue?vue&type=script&lang=js&"
import style0 from "./ResourceFilePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VDivider,VSkeletonLoader})
